//modal

  export default function(container,msg,onSuccess,onCancel){
    $('.modal-info').html(msg);
    $('.modal-cancel').off("click").on("click",function(){
      $(container).css('display','none');
      if(typeof(onCancel) === 'function'){
        onCancel();
      }
    })
    $('.modal-ok').off("click").on("click",function(){
      $(container).css('display','none');
      if(typeof(onSuccess) === 'function'){
        onSuccess();
      }
    })
    $(container).css('display','block');
  }